import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_NEWS_LETTER_KEYS = gql`
  query dataCollectionKeys {
    dataCollectionKeys(data: { type: NEWS_LETTER })
  }
`;
